// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-200d4330] .lx-email-body textarea{min-height:200px !important}[data-v-200d4330] .lx-clickable-cell{text-decoration:underline;cursor:pointer}", ""]);
// Exports
module.exports = exports;
